import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "Blue Cross and Blue Shield of Illinois",
  shortName: "BCBS Illinois",
  slug: "bcbsil-insurance",
  seoTitle:
    "Blue Cross and Blue Shield of Illinois TMS & SPRAVATO® Coverage | Neuro Wellness TMS",
  seoDescription:
    "Learn how Blue Cross and Blue Shield of Illinois policies cover TMS Therapy, SPRAVATO® esketamine, and advanced depression care at Neuro Wellness TMS in Coral Springs, FL.",
  seoKeywords:
    "BCBS Illinois TMS coverage, Blue Cross Blue Shield Illinois SPRAVATO authorization, BCBSIL mental health benefits Coral Springs FL, BCBS Illinois depression treatment Florida",
};

export const BcbsilInsurance = () => <InsurancePageTemplate config={config} />;
export default BcbsilInsurance;
